import React from 'react';
import FormControl from '../../../../Components/Form/FormControl';
import TextArea from '../../../../Components/Base/TextArea/TextArea';
import Form from '../../../../Components/Form/Form';
import SubmitButton from '../../../../Components/Button/SubmitButton';
import {
	useCreateNoteMutation,
	useReAssignCaseMutation,
	useUpdateNoteMutation,
} from '../../../../graphql/graphql';
import { useFormContext } from '../../../../Components/Form/FormContext';

interface Props {
	caseId: string;
	note?: {
		id: string;
		text: string;
	};
	onSuccess?: () => void;
}

const CaseNote: React.FC<Props> = ({ note, caseId, onSuccess }) => {
	const [createNote] = useCreateNoteMutation();
	const [updateNote] = useUpdateNoteMutation();

	const handleCreate = async (values: any) => {
		try {
			await createNote({
				caseId,
				text: values.note,
			}).unwrap();
			onSuccess && onSuccess();
		} catch (e) {}
	};

	const handleUpdate = async (values: any) => {
		if (note) {
			try {
				await updateNote({
					id: note.id,
					text: values.note,
				}).unwrap();
				onSuccess && onSuccess();
			} catch (e) {}
		}
	};

	return (
		<Form defaultValues={{ note: note?.text }}>
			<FormControl label='base.shared.note' name='note' isRequired>
				<TextArea />
			</FormControl>
			<SubmitButton
				onSubmit={note ? handleUpdate : handleCreate}
				title={note ? 'base.shared.edit' : 'base.create'}
			/>
		</Form>
	);
};

export default CaseNote;
